// React
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PROTECTED_ROUTES } from "routes";

// Assets
import logoCollapsed from "assets/img/logo-login.svg";
import logoExtended from "assets/img/meraviglia.svg";

// Styled Components
import { LogoContainer } from "./StyledComponents";

const SidebarLogo = ({ open }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogoClick = (event) => {
    if (event.metaKey || event.ctrlKey) {
      return;
    }
    event.preventDefault();
    navigate(PROTECTED_ROUTES.CLIENTS);
  };

  return (
    <LogoContainer
      open={open}
      component="a"
      href={PROTECTED_ROUTES.CLIENTS}
      onClick={handleLogoClick}
    >
      <img
        src={logoCollapsed}
        alt={t("navigation:logoAlt")}
        style={{
          position: "absolute",
          alignSelf: "center",
          height: 30,
          objectFit: "contain",
          transition: open ? "opacity 0s" : "opacity 0.5s ease-in-out",
          opacity: open ? 0 : 1,
        }}
      />
      <img
        src={logoExtended}
        alt={t("navigation:logoAlt")}
        style={{
          position: "absolute",
          alignSelf: "center",
          height: 30,
          objectFit: "contain",
          transition: open ? "opacity 0.5s ease-in-out" : "opacity 0s",
          opacity: open ? 1 : 0,
        }}
      />
    </LogoContainer>
  );
};

export default SidebarLogo;
